// Agent-side lead message panel — wraps MessageThread with lead context
import { MessageThread } from "@/components/shared/MessageThread";
import { useMessages } from "@/hooks/useMessages";
import { LoadingSpinner } from "@/components/shared";

interface Props {
  leadId: string;
  leadStatus?: string | null;
  onClose?: () => void;
}

export function LeadMessagePanel({ leadId, leadStatus, onClose }: Props) {
  const { messages, loading, sending, error, sendMessage, markRead } = useMessages({
    leadId,
    enabled: true,
  });

  const readOnly = leadStatus === "completed" || leadStatus === "expired" || leadStatus === "blocked";

  return (
    <div className="border border-white/10 rounded-lg bg-midnight/50 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-2 border-b border-white/10 bg-white/5">
        <h4 className="text-sm font-medium text-white/80">Messages</h4>
        {onClose && (
          <button onClick={onClose} className="text-white/40 hover:text-white text-sm">✕</button>
        )}
      </div>
      {loading ? (
        <div className="flex justify-center py-8"><LoadingSpinner /></div>
      ) : error ? (
        <div className="p-4 text-red-400 text-sm">{error}</div>
      ) : (
        <MessageThread
          messages={messages}
          currentRole="agent"
          onSend={sendMessage}
          sending={sending}
          readOnly={readOnly}
          onMarkRead={markRead}
        />
      )}
    </div>
  );
}
